// extracted by mini-css-extract-plugin
export default {"slots":"hg4n_UpaL9xwXFnqejiU","timeSlots":"WsE496CfcchOIuOE12Cs"};